let rootSelector = state => state.system;

export const setRootSelector = selector => {
  rootSelector = selector;
};

export const isAppSuspended = state => rootSelector(state).isAppSuspended;
export const suspendedCounter = state => rootSelector(state).suspendedCounter;
export const isTTSEnabled = state => rootSelector(state)?.ttsEnabled;
